import { useApi } from "../Api";

export const useSapRepository = () => {
    const { GET } = useApi();

    const PATH = "/finance/sap"

    function getPreview(invoiceId: string): Promise<string> {
        return GET(`${PATH}/preview/${invoiceId}`, {}, true);
    }

    return { getPreview };
}